import { PAYMENT_REQUEST_SET, PAYMENT_REQUEST_REMOVE } from '../../actions/payment-request/types';

const emptyState = {};

export default function paymentRequest(state = emptyState, { type, data }) {
  switch (type) {
    case PAYMENT_REQUEST_SET:
      return {
        ...emptyState,
        ...data,
      };
    case PAYMENT_REQUEST_REMOVE:
      return emptyState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/payment-request/index.js